<script lang="ts">
    import {Component, Prop, Vue} from 'vue-facing-decorator'

    @Component
    export class NewOrderRequestNote extends Vue {
        @Prop({required: true}) tour

        render() {
            return null
        }
    }

    export default NewOrderRequestNote
</script>
